import { createSlice } from "@reduxjs/toolkit";

const UserInitialState: {
	userLastName: string;
	userId: number | null;
	defaultAreaId: number | string | null;
	defaultAreaName: string | null;
	userLogged: boolean;
} = {
	userLastName: "",
	userId: null,
	defaultAreaId: null,
	defaultAreaName: "",
	userLogged: false,
};

export const UserReducer = createSlice({
	name: "__",
	initialState: UserInitialState,
	reducers: {
		setUserId(state, { payload }) {
			state.userId = payload;
		},
		setUserLastName(state, { payload }) {
			state.userLastName = payload;
		},
		setDefaultAreaId(state, { payload }) {
			state.defaultAreaId = payload;
		},
		setDefaultAreaName(state, { payload }) {
			state.defaultAreaName = payload;
		},
		setUserLogged(state, { payload }) {
			state.userLogged = payload;
		},
	},
});
